// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { z } from 'zod';
import { inputTypeSchema } from './buy-operation';

export const sellOperationFormSchema = z
  .object({
    type: z.enum(['full', 'partial']),
    percentage: z.number().min(0).max(100),
    shares: z.number().min(0),
    amount: z.number().min(0),
    inputType: inputTypeSchema,
  })
  .refine(
    data =>
      data.type === 'full'
        ? data.percentage === 100
        : data.percentage > 0 && data.percentage <= 100,
    { message: 'Invalid sale percentage', path: ['percentage'] },
  );

export type SellOperationFormData = z.infer<typeof sellOperationFormSchema>;
